const setCurrentAccountAction = async ({ commit }, payload) => {
  commit('setCurrentAccount', payload)
}

const getCurrentAccountAction = ({ state }) => {
  const { currentAccount } = state
  return currentAccount
}
export default {
  setCurrentAccountAction,
  getCurrentAccountAction,
}
